var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0778 2.16174C22.3752 -0.0539145 25.6248 -0.0539129 26.9222 2.16174L47.0439 36.5254C48.333 38.7269 46.7289 41.5 44.1218 41.5H3.87821C1.27111 41.5 -0.333052 38.7269 0.956058 36.5254L21.0778 2.16174Z",
    fill: "#FFF7E6",
    stroke: "#FFAE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7636 15H22.2455L22.5364 28.2725H25.4636L25.7636 15ZM24 34C25.0727 34 25.9909 33.1005 26 31.9807C25.9909 30.8792 25.0727 29.9797 24 29.9797C22.891 29.9797 21.991 30.8792 22.0001 31.9807C21.991 33.1005 22.891 34 24 34Z",
    fill: "#FFAE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.6ea3ff0f.svg";
export { ForwardRef as ReactComponent };